export default {
  apps: [
    {
      name: "Dispatch",
      value: "DISPATCH",
      url: "https://dispatch.rhombuss.ee"
    },
    { name: "Driver", value: "DRIVER", url: "https://beta.rhomtrip.com" },
    {
      name: "Internal",
      value: "INTERNAL",
      url: "https://beta-internal.rhomtrip.com"
    },
    {
      name: "Partners",
      value: "PARTNERS",
      url: "https://beta-partners.rhomtrip.com"
    },
    {
      name: "Suppliers",
      value: "SUPPLIERS",
      url: "https://beta-suppliers.rhomtrip.com/"
    },
    { name: "Web", value: "WEB", url: "https://beta.rhomtrip.com" }
  ],
  modules: [
    {
      name: "Account",
      value: "ACCOUNT",
      icon: "flaticon-profile"
    },
    {
      name: "Areas",
      value: "AREAS",
      icon: "flaticon-radar"
    },
    {
      name: "Customers",
      value: "CUSTOMERS",
      icon: "flaticon-employees"
    },
    {
      name: "Destinations",
      value: "DESTINATIONS",
      icon: "flaticon-pin"
    },
    {
      name: "Drivers",
      value: "DRIVERS",
      icon: "flaticon-driver-license"
    },
    {
      name: "Schedule",
      value: "SCHEDULE",
      icon: "flaticon-history"
    },
    {
      name: "Global",
      value: "GLOBAL",
      icon: "flaticon-global"
    },
    {
      name: "Profile",
      value: "PROFILE",
      icon: "flaticon-profile"
    },
    {
      name: "Rates",
      value: "RATES",
      icon: "flaticon-bold-list"
    },
    {
      name: "Reservations",
      value: "RESERVATIONS",
      icon: "flaticon-calendar"
    },
    {
      name: "Users",
      value: "USERS",
      icon: "flaticon-costumer"
    },
    {
      name: "Vehicles",
      value: "VEHICLES",
      icon: "flaticon-car"
    }
  ]
};
